import axios from 'axios';

const apiClient = axios.create({
  baseURL: 'https://rulla.pro/api/v1',
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((p) => {
    if (error) {
      p.reject(error);
    } else {
      p.resolve(token);
    }
  });
  failedQueue = [];
};

const AUTH_EXCLUDED_PATHS = [
  '/customer/auth/telephone/code',
  '/customer/auth/telephone/verify',
  '/executor/auth/email/code',
  '/executor/auth/email/verify',
  '/executor/auth/telephone/code',
  '/executor/auth/telephone/verify',
  '/auth/refresh',
];

const isExcludedAuthPath = (url = '') =>
  AUTH_EXCLUDED_PATHS.some((path) => url.includes(path));

apiClient.interceptors.request.use(
  (config) => {
    if (!isExcludedAuthPath(config.url)) {
      const token = localStorage.getItem('accessToken');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (!originalRequest) {
      return Promise.reject(error);
    }

    if (isExcludedAuthPath(originalRequest.url)) {
      return Promise.reject(error);
    }

    if (error.response?.status !== 401 || originalRequest._retry) {
      return Promise.reject(error);
    }

    

    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        failedQueue.push({ resolve, reject });
      })
        .then((token) => {
          originalRequest.headers.Authorization = `Bearer ${token}`;
          return apiClient(originalRequest);
        })
        .catch((err) => Promise.reject(err));
    }

    originalRequest._retry = true;
    isRefreshing = true;

    try {
      const refreshResponse = await apiClient.post('/auth/refresh');
      const newAccessToken = refreshResponse.data?.accessToken;

      if (!newAccessToken) {
        throw new Error('Не получен новый access token');
      }

      localStorage.setItem('accessToken', newAccessToken);
      originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;

      processQueue(null, newAccessToken);

      return apiClient(originalRequest);
    } catch (refreshError) {
      processQueue(refreshError, null);

      localStorage.removeItem('accessToken');
      localStorage.removeItem('userRole');

      if (
        !window.location.pathname.includes('/enter') &&
        !window.location.pathname.includes('/login')
      ) {
        window.location.href = '/enter';
      }

      return Promise.reject(refreshError);
    } finally {
      isRefreshing = false;
    }
  }
);

export default apiClient;